import { faker } from '@faker-js/faker'

export const AVAILABLE_CORPORATE_USER_INTEGRATIONS_MOCK_RESPONSE = {
  availableCorporateUserCorporateThirdPartyIntegrations: Array.from({ length: 5 }, () => ({
    id: faker.string.uuid(),
    name: faker.company.name(),
    description: faker.commerce.productDescription(),
    keys: Array.from({ length: faker.number.int({ min: 1, max: 3 }) }, () => ({
      id: faker.string.uuid(),
      name: faker.lorem.word(),
    })),
  })),
}

export const CORPORATE_BY_URL_PREFIX_MOCK_RESPONSE = {
  corporateBySubdomain: {
    id: faker.string.uuid(),
    name: faker.company.name(),
    logoImage: {
      url: faker.image.avatar(),
    },
  },
}

export const CORPORATE_CUSTOM_INTEGRATIONS_MOCK_RESPONSE = {
  corporate: {
    id: faker.string.uuid(),
    integrations: {
      classPass: {
        enabled: false,
        siteIds: [],
      },
    },
    customIntegrations: Array.from({ length: 5 }, () => ({
      integrationId: faker.string.uuid(),
      keys: Array.from({ length: faker.number.int({ min: 1, max: 3 }) }, () => ({
        v1Id: faker.number.int(),
        keyId: faker.string.uuid(),
        value: faker.lorem.words(3),
      })),
    })),
  },
}

export const SET_CORPORATE_USER_CUSTOM_INTEGRATION_MOCK_RESPONSE = {
  data: {
    setCorporateUserCorporateCustomIntegration: {
      id: faker.string.uuid(),
    },
  },
}
